var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game-feature t-a-c"},[_c('img',{staticClass:"d-i-b title-pic",attrs:{"src":_vm.info.titlePic,"alt":""}}),_c('div',{staticClass:"banner-wrap m-0-a p-r"},[_c('img',{staticClass:"p-a banner-bg",attrs:{"src":_vm.info.bannerBg,"alt":""}}),_c('swipe',{attrs:{"id":1,"info":_vm.info.swipeInfo}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0fe2792","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/smsgz/components/index/game-feature.vue
// module id = b8Qp
// module chunks = 0